/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    MONEY_AMOUNT: 'money_amount',
    PERCENTS: 'percents',
};

